<template>
    <div class="inviteFriendsComp" ref="containerRef">
        <div class="row-inline">
            <div class="first-card">
                <el-card shadow="never" class="myTeam_card" :body-style="{ padding: '0' }" style="background: linear-gradient(90deg, #fff 33.93%, #fff2e5 102.59%)">
                    <aboutUsTitleLine title="我的收益" slot="header">
                        <span v-if="![103, 298].includes(userInfo.unitId)">*活动在筹备中，敬请期待...</span>
                        <span class="withdrawal-info-rule" @click="handleShowRuleDlg">
                            <i class="el-icon-document"></i>
                            活动规则
                        </span>
                    </aboutUsTitleLine>
                    <div class="withdrawal-info" ref="withdrawalInfoRef" :style="{ height: dynamicHeight }">
                        <!-- 提现信息 -->
                        <inviteFriendsGridItem @clickItem="handleClickItem" />
                    </div>
                </el-card>
            </div>
            <div class="right-img">
                <img :src="inviteFriendsImageUrls.withdraw_pc_bg" alt="" />
            </div>
        </div>
        <div class="divider"></div>
        <el-card shadow="never" class="myTeam_card">
            <aboutUsTitleLine title="邀请好友" slot="header" />
            <div class="invite-friends-img-container">
                <div class="invite-friends-img" v-for="(url, index) in getInviteFriendsImageUrl" :key="index" @click="handleInviteUrl(index)">
                    <img :src="url" alt="" />
                </div>
            </div>
        </el-card>
        <div class="divider"></div>
        <el-card shadow="never" class="myTeam_card">
            <aboutUsTitleLine title="奖励说明" slot="header"></aboutUsTitleLine>
            <div class="invite-friends-img-container">
                <div class="invite-friends-img" v-for="(url, index) in getAwardInfoImageUrl" :key="index" @click="handleAwardUrl(index)">
                    <img :src="url" alt="" />
                </div>
            </div>
        </el-card>
        <div class="divider"></div>
        <el-card shadow="never" class="myTeam_card">
            <aboutUsTitleLine title="参与步骤" slot="header"></aboutUsTitleLine>
            <div class="invite-friends-img-container">
                <div class="invite-friends-img stepBy2" v-for="(url, index) in getInviteFriendsSteps" :key="index">
                    <img :src="url" alt="" />
                </div>
            </div>
        </el-card>
        <inviteFriendsDlg ref="inviteFriendsDlgRef" />
        <el-dialog title="活动规则" :visible.sync="ruleDlgVisible" width="60%" append-to-body>
            <div v-html="ruleContent" class="rich-content"></div>
        </el-dialog>
        <el-dialog title="" :visible.sync="qrcodeVisible" width="400px" append-to-body>
            <div style="display: flex; justify-content: center; padding: 20px 0">
                <img style="width: 250px" :src="QrCode" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import aboutUsTitleLine from './aboutUsTitleLine.vue';
import inviteFriendsGridItem from './inviteFriendsGridItem.vue';
import { inviteFriendsImageUrls } from '../static/inviteFriendsImageUrls.js';
import inviteFriendsDlg from './inviteFriendsDlg.vue';
import { getClient } from '@/plugins/auth';
import { inviteFriends, downloadPoster,getDicts } from '@/api/request';
import _ from 'lodash';
export default {
    name: 'aboutUsComp',
    components: {
        aboutUsTitleLine,
        inviteFriendsGridItem,
        inviteFriendsDlg
    },
    data() {
        return {
            inviteFriendsImageUrls,
            ruleDlgVisible: false,
            userInfo: JSON.parse(getClient()),
            QrCode: '',
            qrcodeVisible: false,
            inviteQrCode:"",
            wxQrcode:inviteFriendsImageUrls.wxQrcode,
            ruleContent: '',
            dynamicHeight: null,
        };
    },
    computed: {
        getInviteFriendsImageUrl() {
            let urls = [];
            urls.push(this.inviteFriendsImageUrls.invite_f_1);
            urls.push(this.inviteFriendsImageUrls.invite_f_2);
            urls.push(this.inviteFriendsImageUrls.invite_f_3);
            return urls;
        },
        getAwardInfoImageUrl() {
            let urls = [];
            urls.push(this.inviteFriendsImageUrls.award_pc_1);
            urls.push(this.inviteFriendsImageUrls.award_pc_2);
            urls.push(this.inviteFriendsImageUrls.award_pc_3);
            return urls;
        },
        getInviteFriendsSteps() {
            let steps = [];
            steps.push(this.inviteFriendsImageUrls.join_1);
            steps.push(this.inviteFriendsImageUrls.join_2);
            return steps;
        }
    },
    mounted() {
        this.getQrCode();
        // 获取活动规则
        this.getRule();
        this.calculateImageSize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        // 获取活动规则
        getRule() {
            getDicts('commission_rules').then((res) => {
                console.log('getDicts', res);
                if (res.data && res.data.length) {
                    const { dictLabel = '', dictValue = '' } = res.data[0]; //
                    this.ruleContent = dictValue;
                }
            });
        },
        getQrCode() {
            inviteFriends({ width: 100, inviterType: 2 }).then((res) => {
                let byteData = res.qrCodeBytes;
                // 创建图像的 URL
                this.inviteQrCode = 'data:image/png;base64,' + byteData;
            });
        },
        handleShowRuleDlg() {
            this.ruleDlgVisible = true;
        },
        // 点击微信公众号
        handleAwardUrl(index) {
            if (index === 2) {
                this.QrCode = this.wxQrcode;
                this.qrcodeVisible = true;
            }  
        },
        // 点击邀请链接
        handleInviteUrl(index) {
            if (index === 0) {
                // 复制链接
                let baseUrl = `${process.env.VUE_APP_POET}?inviterType=3&inviterPhoneNumber=${this.userInfo.phoneNumber}`;
                this.baseUrl = baseUrl;
                navigator.clipboard
                    .writeText(baseUrl)
                    .then(() => {
                        this.$message.success('邀请链接已复制到剪贴板');
                    })
                    .catch((error) => {
                        this.copyFlag = false;
                        this.$message.warning('复制失败,请手动复制邀请链接');
                    });
            } else if (index === 1) {
                // 查看二维码
                this.QrCode = this.inviteQrCode;
                this.qrcodeVisible = true;
            } else if (index === 2) {
                // 下载海报
                const params = {
                    page: 'pages/index/index',
                    width: 300,
                    scene: ``
                };
                downloadPoster(params).then(async (res) => {
                    console.log('res', res);
                    const { url = '' } = res;
                    if (url) {
                        const imgUrl = `${process.env.VUE_APP_POET}${process.env.VUE_APP_FILE_API}/statics${url}`;
                        window.open(imgUrl, '_blank');
                        // 执行下载 图片
                        try {
                            const response = await fetch(imgUrl);
                            const blob = await response.blob();
                            const downloadUrl = window.URL.createObjectURL(blob);

                            const link = document.createElement('a');
                            link.href = downloadUrl;
                            link.download = `poster_${Date.now()}.png`;
                            document.body.appendChild(link);
                            link.click();

                            // 清理对象URL
                            window.URL.revokeObjectURL(downloadUrl);
                            document.body.removeChild(link);
                        } catch (error) {
                            console.error('下载失败:', error);
                            this.$message.error('海报下载失败');
                        }
                    }
                });
            }
        },
        //
        handleClickItem(e, index) {
            console.log('handleClickItem', e, index);
            if (e.title === '可提现') {
                // 弹出小程序码 -- 路径为提现首页
                // todo 需要等小程序上线
            } else {
                this.$refs.inviteFriendsDlgRef.publicOpen(index);
            }
        },
        // 新增图片尺寸计算方法
    calculateImageSize() {
        const containerWidth = this.$refs.containerRef.offsetWidth;
        const aspectRatio = 0.52; // 16:9比例 (可根据实际需求调整)
        
        // 处理邀请好友图片
        document.querySelectorAll('.invite-friends-img').forEach(el => {
            const parentWidth = el.parentElement.offsetWidth;
            const imgWidth = el.classList.contains('stepBy2') 
                ? parentWidth * 0.49 // 两列布局
                : parentWidth * 0.32; // 三列布局
            
            el.style.width = `${imgWidth}px`;
            el.style.height = `${imgWidth * aspectRatio}px`;
        });

        // 处理右侧图片
        const rightImg = document.querySelector('.right-img');
        // 设置左边框的高度
        if (rightImg) {
            rightImg.style.height = `${containerWidth * 0.15}px`;
            rightImg.style.width = `${containerWidth * 0.3}px`;
        }
        const rowLnline = document.querySelector('.row-inline');
        if (rowLnline) {
            rowLnline.style.height = `${containerWidth * 0.15}px`;
        }
        this.dynamicHeight = `${containerWidth * 0.15 - 62}px`;
    },
    // 防抖的resize处理
    handleResize: _.debounce(function() {
        this.calculateImageSize();
    }, 300)
    },
    
};
</script>
<style scoped lang="scss">
.inviteFriendsComp {
    .row-inline {
        display: flex;
        align-items: center;
        flex: 1;
        .first-card {
            // height: 150px;
            width: 100%;
            height: 100%;
            // fill: linear-gradient(90deg, #FFF 33.93%, #FFF2E5 102.59%);
            // backdrop-filter: blur(31.75px);
        }
        .right-img {
            // width: 300px;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
                // 完全覆盖父元素
            }
        }
    }
    .divider {
        height: 15px;
    }
}
.withdrawal-info {
    // height: 90px;
    display: flex;
    flex: 1;
    align-items: center;
}
.invite-friends-img-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .invite-friends-img {
        // width: 32%;
        // height: 140px;
        img {
            width: 100%;
            height: 100%;
            object-fit: contain; // 保持比例填充
            transition: transform 0.3s ease;
        }
    }
    .stepBy2 {
        width: 49%;
        img {
            width: 100%;
            height: 100%;   
            object-fit: contain; // 保持比例填充
            transition: transform 0.3s ease;
        }
    }
}
.withdrawal-info-rule {
    color: #7e8488;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
</style>
